import { render, staticRenderFns } from "./YTextarea.vue?vue&type=template&id=64dd9679&scoped=true"
import script from "./YTextarea.vue?vue&type=script&lang=js"
export * from "./YTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dd9679",
  null
  
)

export default component.exports